import { render, staticRenderFns } from "./pictureBlock.vue?vue&type=template&id=5bb5545c&"
import script from "./pictureBlock.vue?vue&type=script&lang=js&"
export * from "./pictureBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports